import cx from 'classnames';
import Glyph from 'components/Glyph';
import * as React from 'react';
import Text from 'components/Text';

import './styles/EncryptionNotice.scss';

export default ({ className }: { className: string }) => (
  <Text color="graphite" className={cx('EncryptionNotice', className)}>
    <Glyph name="lock-stroke" className="EncryptionNotice-icon" />
    All data is encrypted and protected with bank-level security.
  </Text>
);
